<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-confirmDialog />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'AP_Period_Title' | translateWF: 'Accounting Periods' }}</h1>
      </div>
    </div>

    <p-panel header="Filter">
      <ng-template pTemplate="icons">
        <p-button
          [label]="'AP_Period_Generate' | translateWF: 'Generate Year'"
          icon="pi pi-calendar-plus"
          variant="outlined"
          (click)="generateYear()"
          [disabled]="isLoading() > 0"
        />
        <p-button [label]="'Load' | translateWF: 'Load'" icon="pi pi-search" (click)="load()" [disabled]="isLoading() > 0" />
      </ng-template>
      <p-card>
        <div class="page__title_buttons">
          <div class="flex items-end gap-2">
            <div class="form-box">
              <label for="year">{{ 'AP_Period_Year' | translateWF: 'Fiscal Year' }}</label>
              <p-inputNumber inputId="year" [formControl]="year" [useGrouping]="false" [min]="2000" [max]="2100" styleClass="w-28" />
            </div>
          </div>
        </div>
      </p-card>
    </p-panel>

    <p-panel header="Results">
      <p-card data-variant="compact">
        @if (hasPeriods()) {
          <p-table [value]="periods()" dataKey="id" styleClass="p-datatable-sm" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 6rem">{{ 'AP_Period_Number' | translateWF: 'Period' }}</th>
                <th>{{ 'AP_Period_Name' | translateWF: 'Name' }}</th>
                <th>{{ 'AP_Period_Start' | translateWF: 'Start' }}</th>
                <th>{{ 'AP_Period_End' | translateWF: 'End' }}</th>
                <th style="width: 10rem">{{ 'Status' | translateWF: 'Status' }}</th>
                <th style="width: 22rem">{{ 'Actions' | translateWF: 'Actions' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-period>
              <tr>
                <td>{{ period.period }}</td>
                <td>{{ period.periodName }}</td>
                <td>{{ period.startDate | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                <td>{{ period.endDate | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(period.status)" [value]="statusLabel(period.status)" />
                </td>
                <td>
                  <div class="row-sm">
                    @switch (period.status) {
                      @case (Status.Open) {
                        <p-button
                          size="small"
                          severity="warn"
                          variant="outlined"
                          icon="pi pi-lock-open"
                          [label]="'AP_Period_Action_ClosingOnly' | translateWF: 'Closing-only'"
                          (click)="setClosingOnly(period)"
                        />
                        <p-button
                          size="small"
                          severity="danger"
                          variant="outlined"
                          icon="pi pi-lock"
                          [label]="'AP_Period_Action_Close' | translateWF: 'Close'"
                          (click)="setClose(period)"
                        />
                      }
                      @case (Status.ClosingOnly) {
                        <p-button
                          size="small"
                          severity="success"
                          variant="outlined"
                          icon="pi pi-unlock"
                          [label]="'AP_Period_Action_Reopen' | translateWF: 'Reopen'"
                          (click)="setReopen(period)"
                        />
                        <p-button
                          size="small"
                          severity="danger"
                          variant="outlined"
                          icon="pi pi-lock"
                          [label]="'AP_Period_Action_Close' | translateWF: 'Close'"
                          (click)="setClose(period)"
                        />
                      }
                      @case (Status.Closed) {
                        <p-button
                          size="small"
                          severity="success"
                          variant="outlined"
                          icon="pi pi-unlock"
                          [label]="'AP_Period_Action_Reopen' | translateWF: 'Reopen'"
                          (click)="setReopen(period)"
                        />
                      }
                    }
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6" class="text-center">{{ 'AP_Period_None' | translateWF: 'No periods for this year.' }}</td>
              </tr>
            </ng-template>
          </p-table>
        } @else {
          <div class="text-center py-8 text-gray-500">
            <p>
              {{
                'AP_Period_NoneHint'
                  | translateWF
                    : 'No accounting periods for this year. Use “Generate Year” to create
          them.'
              }}
            </p>
          </div>
        }
      </p-card>
    </p-panel>
  </div>
</main>
